import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'

export function CatalogBreadcrumb({ current }: { current?: string }) {
  const { t } = useTranslation('common')
  return <nav className="catalog-breadcrumb" aria-label={t('catalog.breadcrumbLabel')}>
    <ol>
      <li><LocalizedLink to="home">{t('nav.home')}</LocalizedLink></li>
      <li><ChevronRight aria-hidden="true" size={16} /><LocalizedLink to="solutions">{t('nav.solutions')}</LocalizedLink></li>
      {current && <li aria-current="page"><ChevronRight aria-hidden="true" size={16} /><span>{current}</span></li>}
    </ol>
  </nav>
}
